<app-display-information-page [title]="pageTitle"
                              [content]="content"></app-display-information-page>
